import { AdminAuthGuard } from "./shared/guard/auth-guard-admin.service";
import { SnailTrailComponent } from "./snail-trail/components/snail-trail.component";
import { BrandingComponent } from "./branding/components/branding.component";
import { TermsAndConditionComponent } from "./termsandcondition/components/terms-condition-list.component";
import { VehicleOccupancy } from "./report/components/vehicle-occupancy.component";
import { AdminDashboardComponent } from "./dashboard/components/admin-dashboard.component";
import { OdometerLogTrailUpdateComponent } from "./odometerlogtrail/components/odometerlogtrail-update.component";
import { OdometerLogTrailListComponent } from "./odometerlogtrail/components/odometerlogtrail-list.component";
import { LanguageHelperComponent } from "./shared/components/language-herlper.component";
import { VTSHistoryListComponent } from "./vtshistory/components/vtshistory-list.component";
import { EventViewerComponent } from "./event-viewer/components/event-viewer.component";
import { VehicleFutureBookingListComponent } from "./vehicle/components/vehiclefuturebooking-list.component";
import { TripDetailReportComponent } from "./tripdetailreport/components/tripdetailreport.components";
import { ImportPersonCsvComponent } from "./import-data/components/import-person-csv.component";
import { VehicleInformationComponent } from "./vehicle/components/vehicle-information.component";
import { SVGDriverComponent } from "./sharedvehiclegroup/components/svgdriver-list.component";
import { BookingOverviewDriverComponent } from "./booking-driver/components/booking-overview-driver.component";
import { BookingDriverComponent } from "./booking-driver/components/booking-driver.component";
import { DriverProfile } from "./driver/components/driver-profile.component";
import { DriverDashboardComponent } from "./dashboard/components/driver-dashboard.component";
import { InboxDriverListComponent } from "./inbox/components/inbox-driver.component";
import { DriverRoleComponent } from "./role/components/driver-role.component";
import { PersonProfileSuccessComponent } from "./personprofile/componets/personprofilesuccess.componets";
import { PersonProfile } from "./personprofile/componets/personprofile.componets";
import { LinkExpiredComponent } from "./shared/components/link-expired.compontnet";
import { UnderConstructionComponent } from "./shared/components/underconstruction.component";
import { BookingApproveComponent } from "./booking/components/booking-approve.component";
import { ChangePasswordSuccessComponent } from "./forgotpassword/components/changepasswordsuccess.component";
import { ChangePasswordComponent } from "./forgotpassword/components/changepassword.component";
import { ForgotPasswordComponent } from "./forgotpassword/components/forgotpassword.component";
// import { VehicleSVGListComponent } from "./vehicle/components/vehicle-svg-list.component";
import { CAdminAuthGuard } from "./shared/guard/auth-guard-cadmin.service";
import { GAdminAuthGuard } from "./shared/guard/auth-guard-gadmin.service";
import { DriverAdminAuthGuard } from "./shared/guard/auth-guard-driveradmin.service";
import { InboxComponent } from "./inbox/components/inbox.component";
import { BookingHistoryComponent } from "./booking/components/booking-history.component";
import { BookingInformationComponent } from "./booking/components/booking-information.component";
import { BookingInformationComponent2 } from "./booking/components/booking-information2.component";
import { BookingInformationComponent3 } from "./booking/components/booking-information3.component";
import { DriverBookingInformationComponent } from "./driver/components/driver-bookinginformation.component";
import { GAdminComponent } from "./role/components/gadmin.component";
import { CAdminComponent } from "./role/components/cadmin.component";
import { TemplateUpdateComponent } from "./template/components/template-update.component";
import { UserProfile } from "./userprofile/components/userprofile.componets";
import { BookingOverviewComponent } from "./booking/components/booking-overview.component";
import { BookingRequestComponent } from "./booking/components/booking-request.component";
import { BookingComponent } from "./booking/components/booking.component";
import { SpecialBookingComponent } from "./booking-special/components/special-booking.component";
import { InvoiceListComponent } from "./invoice/components/invoice-list.component";
import { InvoiceLegacyListComponent } from "./invoice/components/invoice-legacy-list.component";
import { ContractTypeUpdateComponent } from "./contractType/components/contractType-update.component";
import { ContractTypeListComponent } from "./contractType/components/contractType-list.component";
import { ContractTypeGroupUpdateComponent } from "./contracttypegroup/components/contracttypegroup-update.component";
import { ContractTypeGroupListComponent } from "./contracttypegroup/components/contracttypegroup-list.component";
import { SharedVehicleGroupUpdateComponent } from "./sharedvehiclegroup/components/sharedvehiclegroup-update.component";
import { SubscriptionUpdateComponent } from "./sharedvehiclegroupsubscription/components/sharedvehicelsubscription-update.component";
import { SubscriptionListComponent } from "./sharedvehiclegroupsubscription/components/sharedvehiclesubscription-list.component";
import { SubscriptionAvailabilityListComponent } from "./subscriptionavailabilityrestriction/components/subscriptionavailabilityrestriction-list.component";
import { SubscriptionaAvailabilityUpdateComponent } from "./subscriptionavailabilityrestriction/components/subscriptionavailabilityrestriction-update.component";
import { SVGVehicleComponent } from "./sharedvehiclegroup/components/svgvehicle-list.component";
import { SharedVehicleGroupAdminListComponent } from "./sharedvehiclegroupadmin/components/sharedvehiclegroupadmin-list.component";
import { DriverSubscriptionListComponent } from "./driver/components/driversubscription-list.component";
import { DriverSVGListComponent } from "./driver/components/driverSVG-list.component";
import { AdditionalFreeItemsUpdateComponent } from "./additionalfreeitem/components/additionalfreeitems-update.component";
import { AdditionalFreeItemListComponent } from "./additionalfreeitem/components/additionalfreeitems-list.component";
import { TemplateListComponent } from "./template/components/template-list.component";
import { WegoAdminListComponent } from "./wegoadminlist/components/wegoadmin-list.component";
import { SharedVehicleGroupListComponent } from "./sharedvehiclegroup/components/sharedvehiclegroup-list.component";
import { DriverListComponent } from "./driver/components/driver-list.component";
import { SpecialPeriodUpdateComponent } from "./specialperiod/components/specialperiod-update.component";
import { SpecialPeriodListComponent } from "./specialperiod/components/specialperiod-list.component";
import { VehicleAttributeCategoryUpdateComponent } from "./vehicle-attribute-category/components/vehicleattributecategory-update.component";
import { VehicleAttributeCategoryListComponent } from "./vehicle-attribute-category/components/vehicleattributecategory-list.component";
import { VehicleAttributeUpdateComponent } from "./vehicle-attribute/components/vehicleattribute-update.component";
import { VehicleAttributeListComponent } from "./vehicle-attribute/components/vehicleattribute-list.component";
import { VehicleUpdateComponent } from "./vehicle/components/vehicle-update.component";
import { VtsVehicleUpdateComponent } from "./vehicle/components/vtsvehicle-update.component";
import { VtsVehicleListComponent } from "./vehicle/components/vtsvehicle-list.component";
import { VehicleListComponent } from "./vehicle/components/vehicle-list.component";
import { TripHistoryComponent } from "./trip/components/trip-history.component";
import { DriverTripInformationComponent } from "./driver/components/driver-tripinformation.component";
import {
  ApplicationRouteURL,
  PermissionType,
  Permission
} from "./shared/config";
import { CompanyAdminListComponent } from "./company-admin/components/companyAdmin-list.component";
import { CompanyUpdateComponent } from "./company/components/company-update.component";
import { CompanyListComponent } from "./company/components/company-list.component";
import { PersonUpdateComponent } from "./person/components/person-update.component";
import { PersonListComponent } from "./person/components/person-list.component";
import { InstanceUpdateComponent } from "./instance/components/instance-update.component";
import { InstanceListComponent } from "./instance/components/instance-list.component";
import { WAdminAuthGuard } from "./shared/guard/auth-guard-wadmin.service";
import { AuthGuard } from "./shared/guard/auth-guard.service";
import { WegoAdminComponent } from "./role/components/wegoadmin.component";
import { BackofficeComponent } from "./backoffice/components/backoffice.component";
import { DriverLicenceComponent } from "./validatedriverlicence/components/driverlicencedetail.component";
import { UnAuthorizedComponent } from "./shared/components/unauthorized.component";
import { UnAuthenticatedComponent } from "./shared/components/unauthenticated.component";
import { NotFoundComponent } from "./shared/components/notfound.component";
import { LoginComponent } from "./login/components/login.component";
import { NgModule, Component } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { VTSTroubleshootComponent } from "./vts-troubleshoot/components/vts-troubleshoot.component";
import { SignUpComponent } from "./signup/components/signup.component";
import { SignupFormConfigUpdateComponent } from "./signupform/components/signupformconfig-update.compnent";
import { SignupFormConfigListComponent } from "./signupform/components/signupformconfig-list.component";
import { SignupListComponent } from "./signupform/components/signup-list.component";
import { LanguageHelperAPIComponent } from "./shared/components/language-herlper-api.component";
import { DirectDebitFileListComponent } from "./invoice/components/directdebit-file-list.component";
import { BatchUploadPersonComponent } from "./batchuploadperson/component/batch-upload-person.component";
import { MaintenancePlanningReportComponent } from "./report/components/maintenance-planning.component";
import { RevenuepervehicleReportComponent } from "./report/components/revenue-per-vehicle.component";
import { TripDataReportComponent } from "./tripdatareport/components/tripdatareport.component";
import { OrganizationUpdateComponent } from "./organization/components/organization-update.component";
import { OrganizationListComponent } from "./organization/components/organization-list.component";
import { OrganizationAdminListComponent } from "./organizationadmin/components/organizationAdmin-list.component";
import { OrgAdminComponent } from "./role/components/orgadmin.component";
import { OrgAdminAuthGuard } from "./shared/guard/auth-guard-orgadmin.service";
import { OrganizationDriverComponent } from "./organization/components/organizationdriver-list.component";
import { PrivacyNotAllowComponent } from "./shared/components/privacy-not-allow.component";
import { CustomerListComponent } from "./customer/components/customer-list.component";
import { CustomerUpdateComponent } from "./customer/components/customer-update.component";
import { RoleListComponent } from "./role-management/components/role-list.component";
import { RoleUpdateComponent } from "./role-management/components/role-update.component";
import { RoleAvailabilityListComponent } from "./roleavailability/components/roleavailability-list.component";
import { AdminOfCustomerListComponent } from "./admin-of-customer/components/admin-of-customer-list.component";
import { AdminOfInstanceListComponent } from "./admin-of-instance/components/admin-of-instance-list.component";
import { AdminInvitationComponent } from "./admin-invitation/components/admin-invitation.component";
import { AdminInvitationAcceptComponent } from "./admin-invitation/components/admin-invitation-accept.component";
import { AdminInvitationRejectComponent } from "./admin-invitation/components/admin-invitation-reject.component";
import { AdminOfCompanyListComponent } from "./admin-of-company/components/admin-of-comapny-list.component";
import { AdminOfsharedVehicleGroupListComponent } from "./admin-of-sharedvehiclegroup/components/admin-of-sharedvehiclegroup-list.component";
import { AdminOfOrganizationListComponent } from "./admin-of-organization/components/admin-of-organization-list.component";
import { OrganizationSubscriptionComponent } from "./organizationsubscription/components/organization-subscription-list.component";
import { OrganizationDriverListComponent } from "./organizationdriver/components/organization-driver-list.component";
import { AdminComponent } from "./role/components/admin.component";
import { HomePageAuthGuard } from "./shared/guard/auth-guard-home-page.service";
import { ErrorLogListComponent } from "./errorlog/components/errorlog-list.component";
import { ErrorEscalationComponent } from "./errorescalation-configuration/components/errorescalation-list.component";
import { InterfaceStatusListComponent } from "./interfacestatus/components/interfacestatus-list.component";
import { ErrorEscalationUpdateComponent } from "./errorescalation-configuration/components/errorescalation-update.component";
import { InvoiceUpdateComponent } from "./invoice/components/invoice-update.component";
import { CostAndExpenseListComponent } from "./cost-expenses/components/cost-expenses-list.components";
import { KickbackComponent } from "./report/components/kickback.component";
import { CostAndExpenseListDriverComponent } from "./cost-expenses-driver/components/cost-expenses-driver-list.components";
import { InvoicePaymentHistoryListComponent } from "./invoice/components/invoice-payment-history.component";
import { TermsAndConditionAddUpdateComponent } from "./termsandcondition/components/terms-condition-update.component";
import { ViewTermsAndConditionPopupComponent } from "./termsconditionpopup/components/terms-condition-popup.component";
import { CostCenterReportComponent } from "./report/components/cost-center-report.component";
import { SnailTrailDriverComponent } from "./snail-trail-driver/components/snail-trail-driver.component";
import { TCActivityLogDriverComponent } from "./termsandcondition/components/tc-activity-log-driver.component";
import { PrePostTripQuestionComponent } from "./pre-post-trip-question/components/pre-post-trip-question.component";
import { PrePostQuestionsOverviewComponent } from "./pre-post-trip-question-overview/components/pre-post-trip-question-overview.components";
import { ViewPrivacyStatementPopupComponent } from "./privacypopup/component/privacy-statement-popup.component";
import { CreditCardPaymentSuccessComponent } from "./creditcardpaymentpopup/components/creditcard-payment-success.component";
import { CreditCardPaymentFailureComponent } from "./creditcardpaymentpopup/components/creditcard-payment-failure.component";
import { TwoFASelectionPopupComponent } from "./twofa/components/two-fa-selection";
import { TwoFAGoogleSetupPopupComponent } from "./twofa/components/two-fa-google-setup";
import { TwoFAEmailOTPPopupComponent } from "./twofa/components/two-fa-email-otp";
const routes: Routes = [
  {
    path: "",
    component: LoginComponent
  },
  {
    path: "backoffice",
    component: BackofficeComponent
  },
  {
    path: "twofaselection",
    component: TwoFASelectionPopupComponent
  },
  {
    path: "twofagooglesetup",
    component: TwoFAGoogleSetupPopupComponent
  },
  {
    path: "twofaemailotp",
    component: TwoFAEmailOTPPopupComponent
  },
  {
    path: "termsconditionpopup/popup",
    component: ViewTermsAndConditionPopupComponent
  },
  {
    path: "privacystatement/popup",
    component: ViewPrivacyStatementPopupComponent
  },
  {
    path: "validatedriverlicence/driverlicencedetail",
    component: DriverLicenceComponent
  },
  {
    path: "NotFound",
    component: NotFoundComponent
  },
  {
    path: "Unauthenticated",
    component: UnAuthenticatedComponent
  },
  {
    path: "Unauthorized",
    component: UnAuthorizedComponent
  },
  {
    path: "admin",
    component: AdminComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        // redirectTo: ApplicationRouteURL.URL_DASHBOARD_PAGE,
        // canActivate: [AuthGuard]
        canActivate: [AuthGuard, HomePageAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_DASHBOARD_PAGE,
        component: AdminDashboardComponent,
        data: {
          permission: Permission.PR_DASHBOARD,
          permissionType: PermissionType.VIEW
        },
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ORGANIZATION_LIST,
        component: OrganizationListComponent,
        data: {
          permission: Permission.PR_ORGANIZATION_OVERVIEW,
          permissionType: PermissionType.VIEW
        },
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ORGANIZATION_ADD,
        data: {
          permission: Permission.PR_ORGANIZATION_OVERVIEW,
          permissionType: PermissionType.INSERT
        },
        component: OrganizationUpdateComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ORGANIZATION_UPDATE + "/:id",
        data: {
          permission: Permission.PR_ORGANIZATION_OVERVIEW,
          permissionType: PermissionType.EDIT
        },
        component: OrganizationUpdateComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_COMPANY_LIST,
        component: CompanyListComponent,
        data: {
          permission: Permission.PR_COMPANY_OVERVIEW,
          permissionType: PermissionType.VIEW
        },
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_COMPANY_ADD,
        data: {
          permission: Permission.PR_COMPANY_OVERVIEW,
          permissionType: PermissionType.INSERT
        },
        component: CompanyUpdateComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_COMPANY_UPDATE + "/:id",
        data: {
          permission: Permission.PR_COMPANY_OVERVIEW,
          permissionType: PermissionType.EDIT
        },
        component: CompanyUpdateComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SVG_LIST,
        component: SharedVehicleGroupListComponent,
        data: {
          permission: Permission.PR_SHARED_VEHICLE_GROUP_OVERVIEW,
          permissionType: PermissionType.VIEW
        },
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SVG_ADD,
        data: {
          permission: Permission.PR_SHARED_VEHICLE_GROUP_OVERVIEW,
          permissionType: PermissionType.INSERT
        },
        component: SharedVehicleGroupUpdateComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SVG_UPDATE + "/:id",
        data: {
          permission: Permission.PR_SHARED_VEHICLE_GROUP_OVERVIEW,
          permissionType: PermissionType.EDIT
        },
        component: SharedVehicleGroupUpdateComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ADMIN_OF_COMPANY_LIST + "/:id",
        data: {
          permission: Permission.PR_COMPANY_ADMIN,
          permissionType: PermissionType.VIEW
        },
        component: AdminOfCompanyListComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_CUSTOMER_LIST,
        component: CustomerListComponent,
        data: {
          permission: Permission.PR_CUSTOMER_OVERVIEW,
          permissionType: PermissionType.VIEW
        },
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_CUSTOMER_ADD,
        data: {
          permission: Permission.PR_CUSTOMER_OVERVIEW,
          permissionType: PermissionType.INSERT
        },
        component: CustomerUpdateComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_CUSTOMER_UPDATE + "/:id",
        data: {
          permission: Permission.PR_CUSTOMER_OVERVIEW,
          permissionType: PermissionType.EDIT
        },
        component: CustomerUpdateComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ADMIN_OF_INSTANCE_LIST + "/:id",
        data: {
          permission: Permission.PR_INSTANCE_ADMIN_OVERVIEW,
          permissionType: PermissionType.VIEW
        },
        component: AdminOfInstanceListComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_INSTANCE_LIST,
        data: {
          permission: Permission.PR_INSTANCE,
          permissionType: PermissionType.VIEW
        },
        component: InstanceListComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_INSTANCE_UPDATE + "/:id",
        data: {
          permission: Permission.PR_INSTANCE,
          permissionType: PermissionType.EDIT
        },
        component: InstanceUpdateComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_INSTANCE_ADD,
        data: {
          permission: Permission.PR_INSTANCE,
          permissionType: PermissionType.INSERT
        },
        component: InstanceUpdateComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ADMIN_OF_CUSTOMER_LIST + "/:id",
        data: {
          permission: Permission.PR_CUSTOMER_ADMIN_OVERVIEW,
          permissionType: PermissionType.VIEW
        },
        component: AdminOfCustomerListComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ADMIN_OF_ORGANIZATION_LIST + "/:id",
        data: {
          permission: Permission.PR_ORGANIZATION_ADMIN_OVERVIEW,
          permissionType: PermissionType.VIEW
        },
        component: AdminOfOrganizationListComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ADMIN_OF_SHAREDVEHICLEGROUP_LIST + "/:id",
        data: {
          permission: Permission.PR_SHARED_VEHICLE_GROUP_ADMIN_OVERVIEW,
          permissionType: PermissionType.VIEW
        },
        component: AdminOfsharedVehicleGroupListComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_PERSON_LIST,
        data: {
          permission: Permission.PR_PERSON_OVERVIEW,
          permissionType: PermissionType.VIEW
        },
        component: PersonListComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_PERSON_ADD,
        data: {
          permission: Permission.PR_PERSON_OVERVIEW,
          permissionType: PermissionType.INSERT
        },
        component: PersonUpdateComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_PERSON_UPDATE + "/:id",
        data: {
          permission: Permission.PR_PERSON_OVERVIEW,
          permissionType: PermissionType.EDIT
        },
        component: PersonUpdateComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path:
          ApplicationRouteURL.URL_ORGANIZATION_TO_SUBSCRIPTION_LIST + "/:id",
        data: {
          permission: Permission.PR_ORGANIZATION_SUBSCRIPTION_OVERVIEW,
          permissionType: PermissionType.VIEW
        },
        component: OrganizationSubscriptionComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_VTSVEHICLE_LIST,
        data: {
          permission: Permission.PR_VTS_VEHICLE_LIST,
          permissionType: PermissionType.VIEW
        },
        component: VtsVehicleListComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_VTSVEHICLE_ADD,
        data: {
          permission: Permission.PR_VTS_VEHICLE_LIST,
          permissionType: PermissionType.INSERT
        },
        component: VtsVehicleUpdateComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_VTSVEHICLE_UPDATE + "/:id",
        data: {
          permission: Permission.PR_VTS_VEHICLE_LIST,
          permissionType: PermissionType.EDIT
        },
        component: VtsVehicleUpdateComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ORGANIZATION_TO_DRIVER_LIST + "/:id",
        data: {
          permission: Permission.PR_ORGANIZATION_DRIVER_OVERVIEW,
          permissionType: PermissionType.VIEW
        },
        component: OrganizationDriverListComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_VEHICLE_LIST,
        data: {
          permission: Permission.PR_VEHICLES_OVERVIEW,
          permissionType: PermissionType.VIEW
        },
        component: VehicleListComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_VEHICLE_INFO + "/:id",
        data: {
          permission: Permission.PR_VEHICLES_OVERVIEW,
          permissionType: PermissionType.VIEW
        },
        component: VehicleInformationComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_VEHICLE_ADD,
        data: {
          permission: Permission.PR_VEHICLES_OVERVIEW,
          permissionType: PermissionType.INSERT
        },
        component: VehicleUpdateComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_VEHICLE_UPDATE + "/:id",
        data: {
          permission: Permission.PR_VEHICLES_OVERVIEW,
          permissionType: PermissionType.EDIT
        },
        component: VehicleUpdateComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_VEHICLE_UPDATE + "/:id/:isCloneMode",
        data: {
          permission: Permission.PR_VEHICLES_OVERVIEW,
          permissionType: PermissionType.INSERT
        },
        component: VehicleUpdateComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SUBSCRIPTION_LIST + "/:id",
        data: {
          permission: Permission.PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_OVERVIEW,
          permissionType: PermissionType.VIEW
        },
        component: SubscriptionListComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path:
          ApplicationRouteURL.URL_SUBSCRIPTION_UPDATE +
          "/:sharedVehicleGroupHashId/:subscriptionHashId",
        data: {
          permission: Permission.PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_OVERVIEW,
          permissionType: PermissionType.INSERT
        },
        component: SubscriptionUpdateComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SUBSCRIPTION_ADD,
        data: {
          permission: Permission.PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_OVERVIEW,
          permissionType: PermissionType.INSERT
        },
        component: SubscriptionUpdateComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ERRORLOG_List,
        component: ErrorLogListComponent,
        data: {
          permission: Permission.PR_ERRORLOG,
          permissionType: PermissionType.VIEW
        },
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ERROR_ESCALATION_LIST,
        component: ErrorEscalationComponent,
        data: {
          permission: Permission.PR_ERRORESCALATION_OVERVIEW,
          permissionType: PermissionType.VIEW
        },
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ERROR_ESCALATION_UPDATE + "/:id",
        component: ErrorEscalationUpdateComponent,
        data: {
          permission: Permission.PR_ERRORESCALATION_OVERVIEW,
          permissionType: PermissionType.EDIT
        },
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ERROR_ESCALATION_ADD,
        component: ErrorEscalationUpdateComponent,
        data: {
          permission: Permission.PR_ERRORESCALATION_OVERVIEW,
          permissionType: PermissionType.INSERT
        },
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_INTERFACESTATUS_List,
        component: InterfaceStatusListComponent,
        data: {
          permission: Permission.PR_INTERFACE_STATUS,
          permissionType: PermissionType.VIEW
        },
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_VEHICLEATTRIBUTE_LIST,
        data: {
          permission: Permission.PR_VEHICLE_ATTRIBUTE,
          permissionType: PermissionType.VIEW
        },
        component: VehicleAttributeListComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_VEHICLEATTRIBUTE_UPDATE + "/:id",
        data: {
          permission: Permission.PR_VEHICLE_ATTRIBUTE,
          permissionType: PermissionType.EDIT
        },
        component: VehicleAttributeUpdateComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_VEHICLEATTRIBUTE_ADD,
        data: {
          permission: Permission.PR_VEHICLE_ATTRIBUTE,
          permissionType: PermissionType.INSERT
        },
        component: VehicleAttributeUpdateComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_VEHICLEATTRIBUTE_CATEGORY_LIST,
        data: {
          permission: Permission.PR_VEHICLE_ATTRIBUTE_CATEGORIES,
          permissionType: PermissionType.VIEW
        },
        component: VehicleAttributeCategoryListComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_VEHICLEATTRIBUTE_CATEGORY_ADD,
        data: {
          permission: Permission.PR_VEHICLE_ATTRIBUTE_CATEGORIES,
          permissionType: PermissionType.INSERT
        },
        component: VehicleAttributeCategoryUpdateComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_VEHICLEATTRIBUTE_CATEGORY_UPDATE + "/:id",
        data: {
          permission: Permission.PR_VEHICLE_ATTRIBUTE_CATEGORIES,
          permissionType: PermissionType.EDIT
        },
        component: VehicleAttributeCategoryUpdateComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ADDITIONALFREEITEM_LIST,
        data: {
          permission: Permission.PR_ADDITIONAL_FREE_ITEMS,
          permissionType: PermissionType.VIEW
        },
        component: AdditionalFreeItemListComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ADDITIONALFREEITEM_ADD,
        data: {
          permission: Permission.PR_ADDITIONAL_FREE_ITEMS,
          permissionType: PermissionType.INSERT
        },
        component: AdditionalFreeItemsUpdateComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_VTS_TROUBLESHOOT,
        data: {
          permission: Permission.PR_VTS_TROUBLESHOOT,
          permissionType: PermissionType.VIEW
        },
        component: VTSTroubleshootComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_VTS_TROUBLESHOOT + "/:id",
        data: {
          permission: Permission.PR_VTS_TROUBLESHOOT,
          permissionType: PermissionType.VIEW
        },
        component: VTSTroubleshootComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_VTS_HISTORY_LIST,
        data: {
          permission: Permission.PR_VTS_TROUBLESHOOT,
          permissionType: PermissionType.VIEW
        },
        component: VTSHistoryListComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SUBSCRIPTIONAVAILABILITY_LIST + "/:id",
        data: {
          permission:
            Permission.PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_AVAILIBILTY_RESTRICTION_OVERVIEW,
          permissionType: PermissionType.VIEW
        },
        component: SubscriptionAvailabilityListComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path:
          ApplicationRouteURL.URL_SUBSCRIPTIONAVAILABILITY_UPDATE +
          "/:sharedVehicleGroupSubscriptionHashId/:subscriptionAvailabiltiyHashId/:sharedVehicleGroupHashId",
        data: {
          permission:
            Permission.PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_AVAILIBILTY_RESTRICTION_OVERVIEW,
          permissionType: PermissionType.EDIT
        },
        component: SubscriptionaAvailabilityUpdateComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path:
          ApplicationRouteURL.URL_SUBSCRIPTIONAVAILABILITY_ADD +
          "/:sharedVehicleGroupSubscriptionHashId/:sharedVehicleGroupHashId",
        data: {
          permission:
            Permission.PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_AVAILIBILTY_RESTRICTION_OVERVIEW,
          permissionType: PermissionType.INSERT
        },
        component: SubscriptionaAvailabilityUpdateComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_TEMPLATE_LIST,
        data: {
          permission: Permission.PR_TEMPLATES,
          permissionType: PermissionType.VIEW
        },
        component: TemplateListComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_TEMPLATE_UPDATE + "/:id",
        data: {
          permission: Permission.PR_TEMPLATES,
          permissionType: PermissionType.EDIT
        },
        component: TemplateUpdateComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_TEMPLATE_ADD,
        data: {
          permission: Permission.PR_TEMPLATES,
          permissionType: PermissionType.INSERT
        },
        component: TemplateUpdateComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_TERMS_AND_CONDITION_UPDATE + "/:id",
        data: {
          permission: Permission.PR_TERMS_AND_CONDITION,
          permissionType: PermissionType.EDIT
        },
        component: TermsAndConditionAddUpdateComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_TERMS_AND_CONDITION_ADD,
        data: {
          permission: Permission.PR_TERMS_AND_CONDITION,
          permissionType: PermissionType.INSERT
        },
        component: TermsAndConditionAddUpdateComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_BOOKING_INVOICE_LIST,
        data: {
          permission: Permission.PR_INVOICE,
          permissionType: PermissionType.VIEW
        },
        component: InvoiceListComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_BOOKING_INVOICE_LEGACY_LIST,
        data: {
          permission: Permission.PR_INVOICE,
          permissionType: PermissionType.VIEW
        },
        component: InvoiceLegacyListComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_DIRECTDEBIT_LIST,
        data: {
          permission: Permission.PR_DIRECT_DEBIT_FILE,
          permissionType: PermissionType.VIEW
        },
        component: DirectDebitFileListComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ODOMETERLOGTRAIL_LIST,
        data: {
          permission: Permission.PR_ODOMETER_LOG_TRAIL,
          permissionType: PermissionType.VIEW
        },
        component: OdometerLogTrailListComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ODOMETERLOGTRAIL_ADD,
        data: {
          permission: Permission.PR_ODOMETER_LOG_TRAIL,
          permissionType: PermissionType.INSERT
        },
        component: OdometerLogTrailUpdateComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ODOMETERLOGTRAIL_UPDATE + "/:id",
        data: {
          permission: Permission.PR_ODOMETER_LOG_TRAIL,
          permissionType: PermissionType.EDIT
        },
        component: OdometerLogTrailUpdateComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SIGNUPFORM_LIST,
        data: {
          permission: Permission.PR_SIGNUP_FORMS_OVERVIEW,
          permissionType: PermissionType.VIEW
        },
        component: SignupFormConfigListComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SIGNUPFORM_UPDATE + "/:id",
        data: {
          permission: Permission.PR_SIGNUP_FORMS_OVERVIEW,
          permissionType: PermissionType.EDIT
        },
        component: SignupFormConfigUpdateComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SIGNUPFORM_ADD,
        data: {
          permission: Permission.PR_SIGNUP_FORMS_OVERVIEW,
          permissionType: PermissionType.INSERT
        },
        component: SignupFormConfigUpdateComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_DRIVER_LIST,
        data: {
          permission: Permission.PR_DRIVER_OVERVIEW,
          permissionType: PermissionType.VIEW
        },
        component: DriverListComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_BOOKING_OVERVIEW,
        data: {
          permission: Permission.PR_BOOKINGS_OVERVIEW,
          permissionType: PermissionType.VIEW
        },
        component: BookingOverviewComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_BOOKING_REQUEST,
        data: {
          permission: Permission.PR_BOOKINGS_REQUEST,
          permissionType: PermissionType.VIEW
        },
        component: BookingRequestComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SVGVEHICLE_LIST,
        data: {
          permission: Permission.PR_SHARED_VEHICLE_GROUP_VEHICLE_OVERVIEW,
          permissionType: PermissionType.VIEW
        },
        component: SVGVehicleComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SIGNUP_LIST,
        data: {
          permission: Permission.PR_SIGNUPS_OVERVIEW,
          permissionType: PermissionType.VIEW
        },
        component: SignupListComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_CONTRACT_TYPE_GROUP_LIST,
        data: {
          permission:
            Permission.PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_GROUP_OVERVIEW,
          permissionType: PermissionType.VIEW
        },
        component: ContractTypeGroupListComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_CONTRACT_TYPE__GROUP_ADD + "/:svgHashId",
        data: {
          permission:
            Permission.PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_GROUP_OVERVIEW,
          permissionType: PermissionType.INSERT
        },
        component: ContractTypeGroupUpdateComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path:
          ApplicationRouteURL.URL_CONTRACT_TYPE__GROUP_UPDATE +
          "/:svgHashId/:ctgHashId",
        data: {
          permission:
            Permission.PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_GROUP_OVERVIEW,
          permissionType: PermissionType.EDIT
        },
        component: ContractTypeGroupUpdateComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_CONTRACT_TYPE_LIST,
        data: {
          permission: Permission.PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_OVERVIEW,
          permissionType: PermissionType.VIEW
        },
        component: ContractTypeListComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path:
          ApplicationRouteURL.URL_CONTRACT_TYPE_ADD +
          "/:sharedVehicleGroupHashId" +
          "/:contractTypeGroupHashId",
        data: {
          permission: Permission.PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_OVERVIEW,
          permissionType: PermissionType.INSERT
        },
        component: ContractTypeUpdateComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path:
          ApplicationRouteURL.URL_CONTRACT_TYPE_UPDATE +
          "/:sharedVehicleGroupHashId" +
          "/:contractTypeGroupHashId" +
          "/:contractTypeHashId",
        data: {
          permission: Permission.PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_OVERVIEW,
          permissionType: PermissionType.EDIT
        },
        component: ContractTypeUpdateComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_DRIVER_SVG_LIST + "/:id",
        data: {
          permission:
            Permission.PR_DRIVER_SHARED_VEHICLE_GROUP_OVERVIEW,
          permissionType: PermissionType.VIEW
        },
        component: DriverSVGListComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_MAINTENANCE_PLANNING_REPORT,
        data: {
          permission: Permission.PR_MAINTENANCE_PLANNING_REPORT,
          permissionType: PermissionType.VIEW
        },
        component: MaintenancePlanningReportComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_REVENUE_PER_VEHICLE_REPORT,
        data: {
          permission: Permission.PR_REVENUE_PER_VEHICLE_REPORT,
          permissionType: PermissionType.VIEW
        },
        component: RevenuepervehicleReportComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_TRIPDATA_REPORT,
        data: {
          permission: Permission.PR_TRIP_DATA_REPORT,
          permissionType: PermissionType.VIEW
        },
        component: TripDataReportComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_VEHICLE_OCCUPANCY_REPORT,
        data: {
          permission: Permission.PR_VEHICLE_OCCUPANCY_REPORT,
          permissionType: PermissionType.VIEW
        },
        component: VehicleOccupancy,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SNAIL_TRAIL_REPORT,
        data: {
          permission: Permission.PR_SANIL_TRAIL_REPORT,
          permissionType: PermissionType.VIEW
        },
        component: SnailTrailComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_COST_CENTER_REPORT,
        data: {
          permission: Permission.PR_COST_CENTER_REPORT,
          permissionType: PermissionType.VIEW
        },
        component: CostCenterReportComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_KICKBACK_REPORT,
        data: {
          permission: Permission.PR_KICKBACK_REPORT,
          permissionType: PermissionType.VIEW
        },
        component: KickbackComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_BOOKING_INFORMATION + "/:id",
        data: {
          permission: Permission.PR_NORMAL_BOOKING,
          permissionType: PermissionType.VIEW
        },
        component: BookingInformationComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_BOOKING_INFORMATION2 + "/:id",
        data: {
          permission: Permission.PR_NORMAL_BOOKING,
          permissionType: PermissionType.VIEW
        },
        component: BookingInformationComponent2,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_BOOKING_INFORMATION3 + "/:id",
        data: {
          permission: Permission.PR_NORMAL_BOOKING,
          permissionType: PermissionType.VIEW
        },
        component: BookingInformationComponent3,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_BOOKING,
        data: {
          permission: Permission.PR_NORMAL_BOOKING,
          permissionType: PermissionType.INSERT
        },
        component: BookingComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ROLE_LIST,
        data: {
          permission: Permission.PR_ROLE_OVERVIEW,
          permissionType: PermissionType.VIEW
        },
        component: RoleListComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ROLE_UPDATE + "/:id",
        data: {
          permission: Permission.PR_ROLE_OVERVIEW,
          permissionType: PermissionType.EDIT
        },
        component: RoleUpdateComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ROLE_UPDATE,
        data: {
          permission: Permission.PR_ROLE_OVERVIEW,
          permissionType: PermissionType.INSERT
        },
        component: RoleUpdateComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SPECIAL_BOOKING,
        data: {
          permission: Permission.PR_SPECIAL_BOOKING,
          permissionType: PermissionType.INSERT
        },
        component: SpecialBookingComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_BATCHUPLOADPERSON,
        data: {
          permission: Permission.PR_BATCH_UPLOAD_PERSON,
          permissionType: PermissionType.INSERT
        },
        component: BatchUploadPersonComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_IMPORT_PERSON,
        data: {
          permission: Permission.PR_IMPORT_PERSON,
          permissionType: PermissionType.INSERT
        },
        component: ImportPersonCsvComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },

      {
        path: ApplicationRouteURL.URL_BRANDING_PAGE,
        data: {
          permission: Permission.PR_BRANDING,
          permissionType: PermissionType.VIEW
        },
        component: BrandingComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_TERMS_CONDITION_PAGE,
        data: {
          permission: Permission.PR_TERMS_AND_CONDITION,
          permissionType: PermissionType.VIEW
        },
        component: TermsAndConditionComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ROLE_LIST,
        data: {
          permission: Permission.PR_ROLE_OVERVIEW,
          permissionType: PermissionType.VIEW
        },
        component: RoleListComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ROLE_UPDATE,
        data: {
          permission: Permission.PR_ROLE_OVERVIEW,
          permissionType: PermissionType.INSERT
        },
        component: RoleUpdateComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_WEGOADMIN_LIST,
        data: {
          permission: Permission.PR_WEGO_ADMINS,
          permissionType: PermissionType.VIEW
        },
        component: WegoAdminListComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ROLEAVAILABILITY_LIST,
        data: {
          permission: Permission.PR_ROLE_ASSIGN,
          permissionType: PermissionType.VIEW
        },
        component: RoleAvailabilityListComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_EVENT_VIEWER_LIST,
        data: {
          permission: Permission.PR_EVENT_VIEWER,
          permissionType: PermissionType.VIEW
        },
        component: EventViewerComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_PRE_POST_QUESTION_UPDATE,
        data: {
          permission: Permission.PR_PRE_POST_TRIP_SETTING,
          permissionType: PermissionType.VIEW
        },
        component: PrePostTripQuestionComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_PRE_POST_TRIP_QUESTION_OVERVIEW,
        data: {
          permission: Permission.PR_PRE_POST_TRIP_QUESTIONS,
          permissionType: PermissionType.VIEW
        },
        component: PrePostQuestionsOverviewComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_PRE_POST_QUESTION_ADD,
        data: {
          permission: Permission.PR_PRE_POST_TRIP_SETTING,
          permissionType: PermissionType.INSERT
        },
        component: PrePostTripQuestionComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SVGDRIVER_LIST,
        data: {
          permission: Permission.PR_SHARED_VEHICLE_GROUP_DRIVER_OVERVIEW,
          permissionType: PermissionType.VIEW
        },
        component: SVGDriverComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_USER_PROFILE_UPDATE,
        // data: { permission: Permission.PR_USER_PROFILE, permissionType: PermissionType.VIEW },
        component: UserProfile,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_VEHICLE_FUTURE_BOOKING_LIST,
        data: {
          permission: Permission.PR_VEHICLE_FUTURE_BOOKINGS,
          permissionType: PermissionType.VIEW
        },
        component: VehicleFutureBookingListComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_INBOX_PAGE,
        component: InboxComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_COSTANDEXPENSE_LIST,
        data: {
          permission: Permission.PR_COSTANDEXPENSES_LIST,
          permissionType: PermissionType.VIEW
        },
        component: CostAndExpenseListComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_INVOICE_UPDATE + "/:id",
        data: {
          permission: Permission.PR_INVOICE,
          permissionType: PermissionType.EDIT
        },
        component: InvoiceUpdateComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_INVOICE_UPDATE,
        data: {
          permission: Permission.PR_INVOICE,
          permissionType: PermissionType.INSERT
        },
        component: InvoiceUpdateComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_PAYMENT_HISTORY + "/:invoiceHashId",
        data: {
          permission: Permission.PR_INVOICE_PAYMENT_HISTORY_LIST,
          permissionType: PermissionType.VIEW
        },
        component: InvoicePaymentHistoryListComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      }
      // {
      //   redirectTo: "/NotFound"
      // },
      // End Admin
    ]
  },
  {
    path: "wegoadmin",
    component: WegoAdminComponent,
    canActivate: [AuthGuard, WAdminAuthGuard],
    children: [
      {
        path: "",
        redirectTo: ApplicationRouteURL.URL_DASHBOARD_PAGE,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_DASHBOARD_PAGE,
        component: AdminDashboardComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_BRANDING_PAGE,
        component: BrandingComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_TERMS_CONDITION_PAGE,
        component: TermsAndConditionComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_INSTANCE_LIST,
        component: InstanceListComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_INSTANCE_UPDATE + "/:id",
        component: InstanceUpdateComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_PERSON_LIST,
        component: PersonListComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_PERSON_UPDATE + "/:id",
        component: PersonUpdateComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_COMPANY_LIST,
        component: CompanyListComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_COMPANY_UPDATE,
        component: CompanyUpdateComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_COMPANYADMIN_LIST,
        component: CompanyAdminListComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_VEHICLE_LIST,
        component: VehicleListComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_VEHICLE_UPDATE,
        component: VehicleUpdateComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_VTSVEHICLE_UPDATE,
        component: VtsVehicleUpdateComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_VTSVEHICLE_LIST,
        component: VtsVehicleListComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_VTS_TROUBLESHOOT,
        component: VTSTroubleshootComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_VEHICLEATTRIBUTE_LIST,
        component: VehicleAttributeListComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_VEHICLEATTRIBUTE_UPDATE,
        component: VehicleAttributeUpdateComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_VEHICLEATTRIBUTE_ADD,
        component: VehicleAttributeUpdateComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_VEHICLEATTRIBUTE_CATEGORY_LIST,
        component: VehicleAttributeCategoryListComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_VEHICLEATTRIBUTE_CATEGORY_ADD,
        component: VehicleAttributeCategoryUpdateComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_VEHICLEATTRIBUTE_CATEGORY_UPDATE + "/:id",
        component: VehicleAttributeCategoryUpdateComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },

      {
        path: ApplicationRouteURL.URL_SPECIAL_PERIOD_LIST,
        component: SpecialPeriodListComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SPECIAL_PERIOD_UPDATE,
        component: SpecialPeriodUpdateComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_DRIVER_LIST,
        component: DriverListComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SVG_LIST,
        component: SharedVehicleGroupListComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SVG_UPDATE + "/:id",
        component: SharedVehicleGroupUpdateComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SVG_ADD,
        component: SharedVehicleGroupUpdateComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_WEGOADMIN_LIST,
        component: WegoAdminListComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_TEMPLATE_LIST,
        component: TemplateListComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_TEMPLATE_UPDATE + "/:id",
        component: TemplateUpdateComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_TEMPLATE_ADD,
        component: TemplateUpdateComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_TERMS_AND_CONDITION_UPDATE + "/:id",
        component: TermsAndConditionAddUpdateComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_TERMS_AND_CONDITION_ADD,
        component: TermsAndConditionAddUpdateComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_DRIVER_SVG_LIST,
        component: DriverSVGListComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SVGADMIN_LIST,
        component: SharedVehicleGroupAdminListComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SVGVEHICLE_LIST,
        component: SVGVehicleComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SUBSCRIPTION_LIST + "/:id",
        component: SubscriptionListComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path:
          ApplicationRouteURL.URL_SUBSCRIPTION_UPDATE +
          "/:sharedVehicleGroupHashId/:subscriptionHashId",
        component: SubscriptionUpdateComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_CONTRACT_TYPE_GROUP_LIST,
        component: ContractTypeGroupListComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_CONTRACT_TYPE__GROUP_UPDATE,
        component: ContractTypeGroupUpdateComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_CONTRACT_TYPE_LIST,
        component: ContractTypeListComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_CONTRACT_TYPE_UPDATE,
        component: ContractTypeUpdateComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_BOOKING_INVOICE_LIST,
        component: InvoiceListComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_BOOKING_INVOICE_LEGACY_LIST,
        component: InvoiceLegacyListComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SPECIAL_BOOKING,
        component: SpecialBookingComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_BOOKING,
        component: BookingComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_BOOKING_OVERVIEW,
        component: BookingOverviewComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_BOOKING_INFORMATION,
        component: BookingInformationComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_BOOKING_INFORMATION2,
        component: BookingInformationComponent2,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_BOOKING_INFORMATION3,
        component: BookingInformationComponent3,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_USER_PROFILE_UPDATE,
        component: UserProfile,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_INBOX_PAGE,
        component: InboxComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SVGDRIVER_LIST,
        component: SVGDriverComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_VEHICLE_INFO,
        component: VehicleInformationComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_IMPORT_PERSON,
        component: ImportPersonCsvComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      // {
      //   path: ApplicationRouteURL.URL_VEHICLE_SVG_LIST,
      //   component: VehicleSVGListComponent,
      //   canActivate: [AuthGuard, WAdminAuthGuard]
      // },
      {
        path: ApplicationRouteURL.URL_SUBSCRIPTIONAVAILABILITY_LIST + "/:id",
        component: SubscriptionAvailabilityListComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path:
          ApplicationRouteURL.URL_SUBSCRIPTIONAVAILABILITY_UPDATE +
          "/:sharedVehicleGroupSubscriptionHashId/:subscriptionAvailabiltiyHashId/:sharedVehicleGroupHashId",
        component: SubscriptionaAvailabilityUpdateComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path:
          ApplicationRouteURL.URL_SUBSCRIPTIONAVAILABILITY_ADD +
          "/:sharedVehicleGroupSubscriptionHashId/:sharedVehicleGroupHashId",
        component: SubscriptionaAvailabilityUpdateComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ADDITIONALFREEITEM_UPDATE,
        component: AdditionalFreeItemsUpdateComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ADDITIONALFREEITEM_LIST,
        component: AdditionalFreeItemListComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_TRIP_DETAIL_REPORT,
        component: TripDetailReportComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_EVENT_VIEWER_LIST,
        component: EventViewerComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_PRE_POST_TRIP_QUESTION_OVERVIEW,
        component: PrePostQuestionsOverviewComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_VEHICLE_FUTURE_BOOKING_LIST,
        component: VehicleFutureBookingListComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_VTS_HISTORY_LIST,
        component: VTSHistoryListComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_VEHICLE_OCCUPANCY_REPORT,
        component: VehicleOccupancy,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ODOMETERLOGTRAIL_LIST,
        component: OdometerLogTrailListComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ODOMETERLOGTRAIL_UPDATE,
        component: OdometerLogTrailUpdateComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SIGNUPFORM_LIST,
        component: SignupFormConfigListComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SIGNUPFORM_UPDATE + "/:id",
        component: SignupFormConfigUpdateComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SIGNUPFORM_ADD,
        component: SignupFormConfigUpdateComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SIGNUP_LIST,
        component: SignupListComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_DIRECTDEBIT_LIST,
        component: DirectDebitFileListComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_BATCHUPLOADPERSON,
        component: BatchUploadPersonComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_MAINTENANCE_PLANNING_REPORT,
        component: MaintenancePlanningReportComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_REVENUE_PER_VEHICLE_REPORT,
        component: RevenuepervehicleReportComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_TRIPDATA_REPORT,
        component: TripDataReportComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ORGANIZATION_ADD,
        component: OrganizationUpdateComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ORGANIZATION_UPDATE + "/:id",
        component: OrganizationUpdateComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },

      {
        path: ApplicationRouteURL.URL_ORGANIZATION_LIST,
        component: OrganizationListComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ORGANIZATION_ADMIN_LIST,
        component: OrganizationAdminListComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ORGANIZATION_DRIVER_LIST,
        component: OrganizationDriverComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SNAIL_TRAIL_REPORT,
        component: SnailTrailComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_CUSTOMER_LIST,
        component: CustomerListComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_CUSTOMER_UPDATE,
        component: CustomerUpdateComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ROLE_LIST,
        component: RoleListComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ROLE_UPDATE,
        component: RoleUpdateComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ROLEAVAILABILITY_LIST,
        component: RoleAvailabilityListComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ADMIN_OF_CUSTOMER_LIST,
        component: AdminOfCustomerListComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ADMIN_OF_INSTANCE_LIST,
        component: AdminOfInstanceListComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ADMIN_OF_COMPANY_LIST,
        component: AdminOfCompanyListComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ADMIN_OF_SHAREDVEHICLEGROUP_LIST,
        component: AdminOfsharedVehicleGroupListComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ADMIN_OF_ORGANIZATION_LIST,
        component: AdminOfOrganizationListComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ORGANIZATION_TO_SUBSCRIPTION_LIST,
        component: OrganizationSubscriptionComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ORGANIZATION_TO_DRIVER_LIST + "/:id",
        component: OrganizationDriverListComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SUBSCRIPTION_ADD,
        component: SubscriptionUpdateComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_PAYMENT_HISTORY + "/:invoiceHashId",
        data: {
          permission: Permission.PR_INVOICE_PAYMENT_HISTORY,
          permissionType: PermissionType.VIEW
        },
        component: InvoicePaymentHistoryListComponent,
        canActivate: [AuthGuard, AdminAuthGuard]
      }
    ]
  },
  {
    path: "cadmin",
    component: CAdminComponent,
    canActivate: [AuthGuard, CAdminAuthGuard],
    children: [
      {
        path: "",
        redirectTo: ApplicationRouteURL.URL_DASHBOARD_PAGE,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_DASHBOARD_PAGE,
        component: AdminDashboardComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_BRANDING_PAGE,
        component: BrandingComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_TERMS_CONDITION_PAGE,
        component: TermsAndConditionComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_PERSON_LIST,
        component: PersonListComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_PERSON_UPDATE,
        component: PersonUpdateComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_COMPANY_LIST,
        component: CompanyListComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_COMPANY_UPDATE,
        component: CompanyUpdateComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_INBOX_PAGE,
        component: InboxComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_COMPANYADMIN_LIST,
        component: CompanyAdminListComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SVG_LIST,
        component: SharedVehicleGroupListComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SVG_UPDATE,
        component: SharedVehicleGroupUpdateComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SVGVEHICLE_LIST,
        component: SVGVehicleComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SVGADMIN_LIST,
        component: SharedVehicleGroupAdminListComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_VEHICLE_LIST,
        component: VehicleListComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_VEHICLE_UPDATE,
        component: VehicleUpdateComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_VTSVEHICLE_UPDATE,
        component: VtsVehicleUpdateComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_VTSVEHICLE_LIST,
        component: VtsVehicleListComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      // {
      //   path: ApplicationRouteURL.URL_VEHICLE_SVG_LIST,
      //   component: VehicleSVGListComponent,
      //   canActivate: [AuthGuard, CAdminAuthGuard]
      // },
      {
        path: ApplicationRouteURL.URL_DRIVER_LIST,
        component: DriverListComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_DRIVER_SVG_LIST,
        component: DriverSVGListComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_CONTRACT_TYPE_LIST,
        component: ContractTypeListComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_CONTRACT_TYPE_UPDATE,
        component: ContractTypeUpdateComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_CONTRACT_TYPE_GROUP_LIST,
        component: ContractTypeGroupListComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_CONTRACT_TYPE__GROUP_UPDATE,
        component: ContractTypeGroupUpdateComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_VEHICLEATTRIBUTE_UPDATE,
        component: VehicleAttributeUpdateComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_VEHICLEATTRIBUTE_LIST,
        component: VehicleAttributeListComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_BOOKING,
        component: BookingComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_BOOKING_OVERVIEW,
        component: BookingOverviewComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SPECIAL_BOOKING,
        component: SpecialBookingComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_USER_PROFILE_UPDATE,
        component: UserProfile,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SUBSCRIPTION_LIST,
        component: SubscriptionListComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SUBSCRIPTION_UPDATE,
        component: SubscriptionUpdateComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SVGDRIVER_LIST,
        component: SVGDriverComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_BOOKING_INFORMATION,
        component: BookingInformationComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_BOOKING_INFORMATION2,
        component: BookingInformationComponent2,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_BOOKING_INFORMATION3,
        component: BookingInformationComponent3,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_VEHICLE_INFO,
        component: VehicleInformationComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_IMPORT_PERSON,
        component: ImportPersonCsvComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ADDITIONALFREEITEM_UPDATE,
        component: AdditionalFreeItemsUpdateComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ADDITIONALFREEITEM_LIST,
        component: AdditionalFreeItemListComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SUBSCRIPTIONAVAILABILITY_LIST,
        component: SubscriptionAvailabilityListComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SUBSCRIPTIONAVAILABILITY_UPDATE,
        component: SubscriptionaAvailabilityUpdateComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_VEHICLE_FUTURE_BOOKING_LIST,
        component: VehicleFutureBookingListComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_VTS_HISTORY_LIST,
        component: VTSHistoryListComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_TRIP_DETAIL_REPORT,
        component: TripDetailReportComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_VTS_TROUBLESHOOT,
        component: VTSTroubleshootComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_BOOKING_INVOICE_LIST,
        component: InvoiceListComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_BOOKING_INVOICE_LEGACY_LIST,
        component: InvoiceLegacyListComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_VEHICLE_OCCUPANCY_REPORT,
        component: VehicleOccupancy,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ODOMETERLOGTRAIL_LIST,
        component: OdometerLogTrailListComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ODOMETERLOGTRAIL_UPDATE,
        component: OdometerLogTrailUpdateComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SIGNUP_LIST,
        component: SignupListComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_BATCHUPLOADPERSON,
        component: BatchUploadPersonComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_DIRECTDEBIT_LIST,
        component: DirectDebitFileListComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_REVENUE_PER_VEHICLE_REPORT,
        component: RevenuepervehicleReportComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_MAINTENANCE_PLANNING_REPORT,
        component: MaintenancePlanningReportComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_TRIPDATA_REPORT,
        component: TripDataReportComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ORGANIZATION_UPDATE,
        component: OrganizationUpdateComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },

      {
        path: ApplicationRouteURL.URL_ORGANIZATION_LIST,
        component: OrganizationListComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ORGANIZATION_ADMIN_LIST,
        component: OrganizationAdminListComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ORGANIZATION_DRIVER_LIST,
        component: OrganizationDriverComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SNAIL_TRAIL_REPORT,
        component: SnailTrailComponent,
        canActivate: [AuthGuard, CAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ORGANIZATION_TO_SUBSCRIPTION_LIST,
        component: OrganizationSubscriptionComponent,
        canActivate: [AuthGuard, WAdminAuthGuard]
      }
    ]
  },
  {
    path: "gadmin",
    component: GAdminComponent,
    canActivate: [AuthGuard, GAdminAuthGuard],
    children: [
      {
        path: "",
        redirectTo: ApplicationRouteURL.URL_DASHBOARD_PAGE,
        canActivate: [AuthGuard, GAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_DASHBOARD_PAGE,
        component: AdminDashboardComponent,
        canActivate: [AuthGuard, GAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_INBOX_PAGE,
        component: InboxComponent,
        canActivate: [AuthGuard, GAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_DRIVER_LIST,
        component: DriverListComponent,
        canActivate: [AuthGuard, GAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_DRIVER_SVG_LIST,
        component: DriverSVGListComponent,
        canActivate: [AuthGuard, GAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SVG_LIST,
        component: SharedVehicleGroupListComponent,
        canActivate: [AuthGuard, GAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SVG_UPDATE,
        component: SharedVehicleGroupUpdateComponent,
        canActivate: [AuthGuard, GAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SVGVEHICLE_LIST,
        component: SVGVehicleComponent,
        canActivate: [AuthGuard, GAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SVGADMIN_LIST,
        component: SharedVehicleGroupAdminListComponent,
        canActivate: [AuthGuard, GAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_CONTRACT_TYPE_LIST,
        component: ContractTypeListComponent,
        canActivate: [AuthGuard, GAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_CONTRACT_TYPE_UPDATE,
        component: ContractTypeUpdateComponent,
        canActivate: [AuthGuard, GAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_CONTRACT_TYPE_GROUP_LIST,
        component: ContractTypeGroupListComponent,
        canActivate: [AuthGuard, GAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_CONTRACT_TYPE__GROUP_UPDATE,
        component: ContractTypeGroupUpdateComponent,
        canActivate: [AuthGuard, GAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_BOOKING,
        component: BookingComponent,
        canActivate: [AuthGuard, GAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_BOOKING_OVERVIEW,
        component: BookingOverviewComponent,
        canActivate: [AuthGuard, GAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SPECIAL_BOOKING,
        component: SpecialBookingComponent,
        canActivate: [AuthGuard, GAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_USER_PROFILE_UPDATE,
        component: UserProfile,
        canActivate: [AuthGuard, GAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SUBSCRIPTION_LIST,
        component: SubscriptionListComponent,
        canActivate: [AuthGuard, GAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SUBSCRIPTION_UPDATE,
        component: SubscriptionUpdateComponent,
        canActivate: [AuthGuard, GAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SVGDRIVER_LIST,
        component: SVGDriverComponent,
        canActivate: [AuthGuard, GAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_BOOKING_INFORMATION,
        component: BookingInformationComponent,
        canActivate: [AuthGuard, GAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_BOOKING_INFORMATION2,
        component: BookingInformationComponent2,
        canActivate: [AuthGuard, GAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_BOOKING_INFORMATION3,
        component: BookingInformationComponent3,
        canActivate: [AuthGuard, GAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ADDITIONALFREEITEM_UPDATE,
        component: AdditionalFreeItemsUpdateComponent,
        canActivate: [AuthGuard, GAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ADDITIONALFREEITEM_LIST,
        component: AdditionalFreeItemListComponent,
        canActivate: [AuthGuard, GAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SUBSCRIPTIONAVAILABILITY_LIST,
        component: SubscriptionAvailabilityListComponent,
        canActivate: [AuthGuard, GAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SUBSCRIPTIONAVAILABILITY_UPDATE,
        component: SubscriptionaAvailabilityUpdateComponent,
        canActivate: [AuthGuard, GAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_VEHICLE_UPDATE,
        component: VehicleUpdateComponent,
        canActivate: [AuthGuard, GAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_VEHICLE_INFO,
        component: VehicleInformationComponent,
        canActivate: [AuthGuard, GAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_VEHICLE_OCCUPANCY_REPORT,
        component: VehicleOccupancy,
        canActivate: [AuthGuard, GAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ODOMETERLOGTRAIL_LIST,
        component: OdometerLogTrailListComponent,
        canActivate: [AuthGuard, GAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ODOMETERLOGTRAIL_UPDATE,
        component: OdometerLogTrailUpdateComponent,
        canActivate: [AuthGuard, GAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SIGNUP_LIST,
        component: SignupListComponent,
        canActivate: [AuthGuard, GAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_BATCHUPLOADPERSON,
        component: BatchUploadPersonComponent,
        canActivate: [AuthGuard, GAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_REVENUE_PER_VEHICLE_REPORT,
        component: RevenuepervehicleReportComponent,
        canActivate: [AuthGuard, GAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_MAINTENANCE_PLANNING_REPORT,
        component: MaintenancePlanningReportComponent,
        canActivate: [AuthGuard, GAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_TRIPDATA_REPORT,
        component: TripDataReportComponent,
        canActivate: [AuthGuard, GAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ORGANIZATION_UPDATE,
        component: OrganizationUpdateComponent,
        canActivate: [AuthGuard, GAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ORGANIZATION_LIST,
        component: OrganizationListComponent,
        canActivate: [AuthGuard, GAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ORGANIZATION_ADMIN_LIST,
        component: OrganizationAdminListComponent,
        canActivate: [AuthGuard, GAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ORGANIZATION_DRIVER_LIST,
        component: OrganizationDriverComponent,
        canActivate: [AuthGuard, GAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_PERSON_UPDATE,
        component: PersonUpdateComponent,
        canActivate: [AuthGuard, GAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SNAIL_TRAIL_REPORT,
        component: SnailTrailComponent,
        canActivate: [AuthGuard, GAdminAuthGuard]
      }
    ]
  },
  {
    path: "driver",
    component: DriverRoleComponent,
    canActivate: [AuthGuard, DriverAdminAuthGuard],
    children: [
      {
        path: "",
        redirectTo: ApplicationRouteURL.URL_DASHBOARD_PAGE,
        canActivate: [AuthGuard, DriverAdminAuthGuard]
      },
      {
        path: "creditCardPayment/success",
        component: CreditCardPaymentSuccessComponent,
        //canActivate: [AuthGuard, DriverAdminAuthGuard]
      },
      {
        path: "creditCardPayment/failure",
        component: CreditCardPaymentFailureComponent,
        //canActivate: [AuthGuard, DriverAdminAuthGuard]
      },
      // {
      //   path: ApplicationRouteURL.URL_TERMS_AND_CONDITION_POPUP,
      //   component: ViewTermsAndConditionPopupComponent,
      //   canActivate: [AuthGuard]
      // },
      {
        path: ApplicationRouteURL.URL_DASHBOARD_PAGE,
        component: DriverDashboardComponent,
        canActivate: [AuthGuard, DriverAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_INBOX_PAGE,
        component: InboxDriverListComponent,
        canActivate: [AuthGuard, DriverAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_BOOKING,
        component: BookingDriverComponent,
        canActivate: [AuthGuard, DriverAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_BOOKING_OVERVIEW,
        component: BookingOverviewDriverComponent,
        canActivate: [AuthGuard, DriverAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_BOOKING_HISTORY,
        component: BookingHistoryComponent,
        canActivate: [AuthGuard, DriverAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_COST_EXPENSE_DRIVER_LIST,
        component: CostAndExpenseListDriverComponent,
        canActivate: [AuthGuard, DriverAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_USER_PROFILE_UPDATE,
        component: UserProfile,
        canActivate: [AuthGuard, DriverAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SUBSCRIPTION_LIST,
        component: DriverSubscriptionListComponent,
        canActivate: [AuthGuard, DriverAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_BOOKING_INFORMATION_DRIVER,
        component: DriverBookingInformationComponent,
        canActivate: [AuthGuard, DriverAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_DRIVER_PROFILE,
        component: DriverProfile,
        canActivate: [AuthGuard, DriverAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_TERMS_CONDITION_ACTIVITY_DRIVER,
        component: TCActivityLogDriverComponent,
        canActivate: [AuthGuard, DriverAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SNAIL_TRAIL_DRIVER,
        component: SnailTrailDriverComponent,
        canActivate: [AuthGuard, DriverAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_TRIP_HISTORY,
        component: TripHistoryComponent,
        canActivate: [AuthGuard, DriverAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_TRIP_INFORMATION_DRIVER,
        component: DriverTripInformationComponent,
        canActivate: [AuthGuard, DriverAdminAuthGuard]
      },
      //{ path: ApplicationRouteURL.URL_DRIVER_LICENCE, component: DriverLicenceComponent, canActivate: [AuthGuard, DriverAdminAuthGuard] },
    ]
  },
  {
    path: "orgadmin",
    component: OrgAdminComponent,
    canActivate: [AuthGuard, OrgAdminAuthGuard],
    children: [
      {
        path: "",
        redirectTo: ApplicationRouteURL.URL_DASHBOARD_PAGE,
        canActivate: [AuthGuard, OrgAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_DASHBOARD_PAGE,
        component: AdminDashboardComponent,
        canActivate: [AuthGuard, OrgAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SVG_LIST,
        component: SharedVehicleGroupListComponent,
        canActivate: [AuthGuard, OrgAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SVG_UPDATE,
        component: SharedVehicleGroupUpdateComponent,
        canActivate: [AuthGuard, OrgAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SVGVEHICLE_LIST,
        component: SVGVehicleComponent,
        canActivate: [AuthGuard, OrgAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_DRIVER_LIST,
        component: DriverListComponent,
        canActivate: [AuthGuard, OrgAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_BOOKING,
        component: BookingComponent,
        canActivate: [AuthGuard, OrgAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_BOOKING_OVERVIEW,
        component: BookingOverviewComponent,
        canActivate: [AuthGuard, OrgAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_BOOKING_INFORMATION,
        component: BookingInformationComponent,
        canActivate: [AuthGuard, OrgAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_BOOKING_INFORMATION2,
        component: BookingInformationComponent2,
        canActivate: [AuthGuard, OrgAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_BOOKING_INFORMATION3,
        component: BookingInformationComponent3,
        canActivate: [AuthGuard, OrgAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_PERSON_LIST,
        component: PersonListComponent,
        canActivate: [AuthGuard, OrgAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_PERSON_UPDATE,
        component: PersonUpdateComponent,
        canActivate: [AuthGuard, OrgAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_DRIVER_SVG_LIST,
        component: DriverSVGListComponent,
        canActivate: [AuthGuard, OrgAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SUBSCRIPTION_LIST,
        component: DriverSubscriptionListComponent,
        canActivate: [AuthGuard, OrgAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ORGANIZATION_UPDATE,
        component: OrganizationUpdateComponent,
        canActivate: [AuthGuard, OrgAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ORGANIZATION_LIST,
        component: OrganizationListComponent,
        canActivate: [AuthGuard, OrgAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_BOOKING_INVOICE_LIST,
        component: InvoiceListComponent,
        canActivate: [AuthGuard, OrgAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_BOOKING_INVOICE_LEGACY_LIST,
        component: InvoiceLegacyListComponent,
        canActivate: [AuthGuard, OrgAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ORGANIZATION_ADMIN_LIST,
        component: OrganizationAdminListComponent,
        canActivate: [AuthGuard, OrgAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_ORGANIZATION_DRIVER_LIST,
        component: OrganizationDriverComponent,
        canActivate: [AuthGuard, OrgAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_SVGDRIVER_LIST,
        component: SVGDriverComponent,
        canActivate: [AuthGuard, OrgAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_BATCHUPLOADPERSON,
        component: BatchUploadPersonComponent,
        canActivate: [AuthGuard, OrgAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_USER_PROFILE_UPDATE,
        component: UserProfile,
        canActivate: [AuthGuard, OrgAdminAuthGuard]
      },
      {
        path: ApplicationRouteURL.URL_INBOX_PAGE,
        component: InboxComponent,
        canActivate: [AuthGuard, OrgAdminAuthGuard]
      }
    ]
  },
  {
    path: "",
    component: LoginComponent
  },
  {
    path: "backoffice",
    component: BackofficeComponent
  },
  {
    path: "validatedriverlicence/driverlicencedetail",
    component: DriverLicenceComponent
  },
  {
    path: "personprofile",
    component: PersonProfile
  },
  {
    path: "invitation",
    component: AdminInvitationComponent
  },
  {
    path: "invitationaccept",
    component: AdminInvitationAcceptComponent
  },
  {
    path: "invitationreject",
    component: AdminInvitationRejectComponent
  },

  {
    path: "personprofile/success",
    component: PersonProfileSuccessComponent
  },
  {
    path: "Linkexpired",
    component: LinkExpiredComponent
  },
  {
    path: "forgotpassword",
    component: ForgotPasswordComponent
  },
  {
    path: "changepassword",
    component: ChangePasswordComponent
  },
  {
    path: "changepassword/success",
    component: ChangePasswordSuccessComponent
  },
  {
    path: "underconstruction",
    component: UnderConstructionComponent
  },
  {
    path: "NotFound",
    component: NotFoundComponent
  },
  {
    path: "privacy-not-allow",
    component: PrivacyNotAllowComponent
  },
  {
    path: "Unauthenticated",
    component: UnAuthenticatedComponent
  },
  {
    path: "Unauthorized",
    component: UnAuthorizedComponent
  },
  {
    path: "language-helper",
    component: LanguageHelperComponent
  },
  {
    path: "language-helper-api",
    component: LanguageHelperAPIComponent
  },
  {
    path: "booking/approve",
    component: BookingApproveComponent,
   // canActivate: [AuthGuard]
  },
  {
    path: "signup/:id",
    component: SignUpComponent
  },
  {
    path: "**",
    redirectTo: "/NotFound"
  }
];
@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/app-routing.module.ts